module.exports = __webpack_public_path__ + "img/circle24.a17bb2c2.png";